import * as api from '../api-client.js';
import { navigate, toast } from '../ui/util.js';
import { DEFAULT_PATH } from '../ui/routes.js';

export function renderLogin(container) {
  container.innerHTML = `
    <div class="login-wrap">
      <form class="card login-card" id="loginForm">
        <h1>Đăng nhập</h1>
        <p>Farmer Survey Platform</p>
        <div class="form-row">
          <label for="loginUsername">Tên đăng nhập</label>
          <input id="loginUsername" name="username" autocomplete="username" required>
        </div>
        <div class="form-row">
          <label for="loginPassword">Mật khẩu</label>
          <input id="loginPassword" name="password" type="password" autocomplete="current-password" required>
        </div>
        <div class="error-text" id="loginError" hidden></div>
        <button class="btn block" type="submit" id="loginSubmit">Đăng nhập</button>
      </form>
    </div>`;

  const form = container.querySelector('#loginForm');
  const errBox = container.querySelector('#loginError');
  const submitBtn = container.querySelector('#loginSubmit');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errBox.hidden = true;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Đang đăng nhập...';
    try {
      await api.login(form.username.value.trim(), form.password.value);
      toast('Đăng nhập thành công');
      navigate(`#${DEFAULT_PATH}`);
    } catch (err) {
      errBox.textContent = err.message || 'Đăng nhập thất bại';
      errBox.hidden = false;
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Đăng nhập';
    }
  });
}
